var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-img',{staticClass:"mt-3",attrs:{"src":_vm.src,"contain":"","height":"200"}}),_c('div',{staticClass:"text-center mx-5"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('P',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }